import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'
import moment from 'moment'
import { IModalBase, initialDataList, initialModalBase } from '@interfaces/commonInterfaces'

export type GetListOrderPayload = string | { queryStr: string; allBranch?: boolean }

export interface IState {
  orderList?: any
  orderManageList?: any
  orderPickList?: any
  orderCheckList?: any
  orderPackList?: any
  orderScheduleList?: any
  orderShipList?: any

  reloadOrderList?: string | null
  reloadOrderManageList?: string | null
  reloadOrderCheckList?: string | null
  reloadOrderPickList?: string | null
  reloadOrderPackList?: string | null
  reloadOrderScheduleList?: string | null
  reloadOrderShipList?: string | null

  modalOrder?: IModalBase
  modalOrderUpdatePicker?: IModalBase
}

const initialState: IState = {
  orderList: initialDataList,
  orderManageList: initialDataList,
  orderPickList: initialDataList,
  orderCheckList: initialDataList,
  orderPackList: initialDataList,
  orderScheduleList: initialDataList,
  orderShipList: initialDataList,

  reloadOrderList: null,
  reloadOrderManageList: null,
  reloadOrderCheckList: null,
  reloadOrderPickList: null,
  reloadOrderPackList: null,
  reloadOrderScheduleList: null,
  reloadOrderShipList: null,

  modalOrder: initialModalBase,
  modalOrderUpdatePicker: initialModalBase,
}

export const orderDucks = createSlice({
  name: 'order',
  initialState,
  reducers: {


    getListOrder: (state: RootState, action: PayloadAction<GetListOrderPayload>) => {
      const p = action.payload
      const queryStr = typeof p === 'string' ? p : p.queryStr
      state.orderList = { loading: true, queryStr }
    },
    getListOrderSuccess: (state, action: PayloadAction<any>) => {
      state.orderList = { loading: false, ...action.payload }
    },
    getListOrderFail: (state, action: PayloadAction<any>) => {
      state.orderList = { loading: false, ...action.payload }
    },
    setReloadOrderList: (state: RootState) => {
      state.reloadOrderList = String(moment())
    },

    getListOrderManage: (state: RootState, action: PayloadAction<any>) => {
      state.orderManageList = { loading: true, queryStr: action.payload }
    },
    getListOrderManageSuccess: (state, action: PayloadAction<any>) => {
      state.orderManageList = { loading: false, ...action.payload }
    },
    getListOrderManageFail: (state, action: PayloadAction<any>) => {
      state.orderManageList = { loading: false, ...action.payload }
    },
    setReloadOrderManageList: (state) => {
      state.reloadOrderManageList = String(moment())
    },

    // Picking Orders
    getListOrderPick: (state, action: PayloadAction<any>) => {
      state.orderPickList = { ...state.orderPickList, queryStr: action.payload }
    },
    getListOrderPickSuccess: (state, action: PayloadAction<any>) => {
      state.orderPickList = { loading: false, ...action.payload }
    },
    getListOrderPickFail: (state, action: PayloadAction<any>) => {
      state.orderPickList = { loading: false, ...action.payload }
    },
    setReloadOrderPickList: (state) => {
      state.reloadOrderPickList = String(moment())
    },

    // Checking Orders
    getListOrderCheck: (state, action: PayloadAction<any>) => {
      state.orderCheckList = { ...state.orderCheckList, queryStr: action.payload }
    },
    getListOrderCheckSuccess: (state, action: PayloadAction<any>) => {
      state.orderCheckList = { loading: false, ...action.payload }
    },
    getListOrderCheckFail: (state, action: PayloadAction<any>) => {
      state.orderCheckList = { loading: false, ...action.payload }
    },
    setReloadOrderCheckList: (state) => {
      state.reloadOrderCheckList = String(moment())
    },

    // Packing Orders
    getListOrderPack: (state, action: PayloadAction<any>) => {
      state.orderPackList = { ...state.orderPackList, queryStr: action.payload }
    },
    getListOrderPackSuccess: (state, action: PayloadAction<any>) => {
      state.orderPackList = { loading: false, ...action.payload }
    },
    getListOrderPackFail: (state, action: PayloadAction<any>) => {
      state.orderPackList = { loading: false, ...action.payload }
    },
    setReloadOrderPackList: (state) => {
      state.reloadOrderPackList = String(moment())
    },

    // Scheduling Orders
    getListOrderSchedule: (state, action: PayloadAction<any>) => {
      state.orderScheduleList = { ...state.orderScheduleList, queryStr: action.payload }
    },
    getListOrderScheduleSuccess: (state, action: PayloadAction<any>) => {
      state.orderScheduleList = { loading: false, ...action.payload }
    },
    getListOrderScheduleFail: (state, action: PayloadAction<any>) => {
      state.orderScheduleList = { loading: false, ...action.payload }
    },
    setReloadOrderScheduleList: (state) => {
      state.reloadOrderScheduleList = String(moment())
    },

    // Shipping Orders
    getListOrderShip: (state, action: PayloadAction<any>) => {
      state.orderShipList = { ...state.orderShipList, queryStr: action.payload }
    },
    getListOrderShipSuccess: (state, action: PayloadAction<any>) => {
      state.orderShipList = { loading: false, ...action.payload }
    },
    getListOrderShipFail: (state, action: PayloadAction<any>) => {
      state.orderShipList = { loading: false, ...action.payload }
    },
    setReloadOrderShipList: (state) => {
      state.reloadOrderShipList = String(moment())
    },




    setModalOrder: (state, action: PayloadAction<IModalBase>) => {
      state.modalOrder = action.payload
    },
    setModalOrderUpdatePicker: (state, action: PayloadAction<IModalBase>) => {
      state.modalOrderUpdatePicker = action.payload
    },

  },
})

// Action creators are generated for each case reducer function
export const {
  getListOrder,
  getListOrderSuccess,
  getListOrderFail,
  setReloadOrderList,

  getListOrderManage,
  getListOrderManageSuccess,
  getListOrderManageFail,
  setReloadOrderManageList,

  getListOrderPick,
  getListOrderPickSuccess,
  getListOrderPickFail,
  setReloadOrderPickList,

  getListOrderCheck,
  getListOrderCheckSuccess,
  getListOrderCheckFail,
  setReloadOrderCheckList,

  getListOrderPack,
  getListOrderPackSuccess,
  getListOrderPackFail,
  setReloadOrderPackList,

  getListOrderSchedule,
  getListOrderScheduleSuccess,
  getListOrderScheduleFail,
  setReloadOrderScheduleList,

  getListOrderShip,
  getListOrderShipSuccess,
  getListOrderShipFail,
  setReloadOrderShipList,

  setModalOrder,
  setModalOrderUpdatePicker,
} = orderDucks.actions

export default orderDucks.reducer
